import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-orthopedic-features-grid.js';

const defaultItems = [
  {
    image: 'https://cdn.skyfastimg.com/images/2026/06/22/image-6a38f7c0c67b1d2b9c4f2e77.png',
    content: `<h2 style="text-align:center;"><span style="font-size:22px;"><strong>PLANTAR FASCIITIS</strong></span></h2><p style="text-align:center;"><span style="font-size:22px;">Sharp heel pain caused by micro-tears from poor arch support.</span></p>`,
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/06/22/image-6a38f78d5dbf3f9fb0e0d0d0.png',
    content: `<h2 style="text-align:center;"><span style="font-size:22px;"><strong>PERIPHERAL NEUROPATHY</strong></span></h2><p style="text-align:center;"><span style="font-size:22px;">Burning &amp; numbness that pinched nerves and cut off circulation.</span></p>`,
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/06/22/image-6a38f7a1bc8ee5d2691c5ea6.png',
    content: `<h2 style="text-align:center;"><span style="font-size:22px;"><strong>BUNION INFLAMMATION</strong></span></h2><p style="text-align:center;"><span style="font-size:20px;">Red, swollen big toe joints forced into unnatural positions</span></p>`,
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/06/22/image-6a38f7b2a90a98e3fb37ba16.png',
    content: `<h2 style="text-align:center;"><span style="font-size:22px;"><strong>ARTHRITIS &amp; SWOLLEN JOINTS</strong></span></h2><p style="text-align:center;"><span style="font-size:20px;">Fluid buildup and stiffness from walking on hard surfaces..</span></p>`,
  },
];

const renderItem = item => `
  <div class="orthopedic-features-grid__item" data-attribute="orthopedic-features-grid__item">
    <div class="orthopedic-features-grid__item-image-wrap">
      <img
        data-attribute="orthopedic-features-grid__item-image"
        src="${item.image}"
        alt=""
      />
    </div>
    <div
      class="orthopedic-features-grid__item-content"
      data-attribute="orthopedic-features-grid__item-content"
    >
      ${item.content}
    </div>
  </div>`;

const contentHtml = `
  <div class="orthopedic-features-grid container" data-attribute="orthopedic-features-grid-content">
    <div
      class="orthopedic-features-grid__header"
      data-attribute="orthopedic-features-grid__header"
    >
      <h2 style="text-align: center">
        <span style="color: hsl(201, 100%, 29%); font-size: 48px"
          ><strong>WHY YOUR FEET ARE SCREAMING FOR HELP?</strong></span
        >
      </h2>
      <p style="text-align: center">
        <span style="color: hsl(228, 3%, 34%); font-size: 22px"
          ><strong>75% of adults</strong> will experience debilitating foot pain at
          some point. It's not just "getting old"</span
        >
      </p>
      <p style="text-align: center">
        <span style="color: hsl(228, 3%, 34%); font-size: 22px"
          >It's a sign that <strong>your foundation is collapsing!!!</strong></span
        >
      </p>
      <p style="text-align: center">
        <span style="color: hsl(228, 3%, 34%); font-size: 22px"
          >If you recognize any of these symptoms, your current footwear is likely
          causing permanent damage.</span
        >
      </p>
    </div>
    <div
      class="orthopedic-features-grid__body"
      data-attribute="orthopedic-features-grid__body"
      data-background="#006196"
      data-text-color="#ffffff"
      data-items-per-row-mobile="1"
      data-items-per-row-desktop="4"
      data-items-gap="24"
      style="
        --body-background: #006196;
        --items-per-row-mobile: 1;
        --items-per-row-desktop: 4;
        --items-gap: 24px;
      "
    >
      <div class="orthopedic-features-grid__list" data-attribute="orthopedic-features-grid__list">
        ${defaultItems.map(renderItem).join('')}
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  topPadding: true,
  bottomPadding: true,
});
